import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Autocomplete, Modal, showAlert } from '../../components';

import styles from './IssueLinkingPopup.scss';
import uiStyles from '../../styles/ui.scss';
import debounce from 'lodash/debounce';
import { createIssue, getIssues, linkMessageWithIssue } from '../../services/apiIssues';


const mapStateToProps = state => {
  return {
    currentCompany: state.currentCompany,
  };
};


@connect(mapStateToProps)
export class IssueLinkingPopup extends Component {

  state = {
    autocompleteQuery: '',
    autocompleteOptions: [],
    autocompleteSelectedOption: null,
  };

  debouncedOnAutocompleteType = debounce(this.onAutocompleteType.bind(this), 400);
  autocomplete = React.createRef();

  componentDidMount(){
    this.focusInput();
  }

  onAutocompleteType(query){
    const { currentCompany } = this.props;
    return getIssues(currentCompany.id, query).then(tasks => {
      const autocompleteOptions = tasks.map(issue => {
        return {
          title: issue.title,
          value: issue.id,
        };
      });
      autocompleteOptions.push({
        title: query,
        value: 'new',
      });
      this.setState({ autocompleteOptions });
    });
  };

  onAutocompleteSelect = (autocompleteSelectedOption) => {
    this.setState({ autocompleteSelectedOption });
  };

  onSelectedOptionRemove = () => {
    this.setState({ autocompleteSelectedOption: null });
    this.focusInput();
  };

  onSubmitButtonClick = () => {
    const { messageId, currentCompany } = this.props;
    const { autocompleteQuery, autocompleteSelectedOption } = this.state;
    this.setState({ isSubmitting: true });

    if (autocompleteSelectedOption && autocompleteSelectedOption?.title?.trim?.()) {
      if (autocompleteSelectedOption?.value === 'new') {
        createIssue(currentCompany.id, autocompleteQuery, messageId)
          .then(this.onSubmitSuccess)
          .catch(e => {
            if (e.errorType === 'HAS_ALREADY_BEEN_TAKEN') {
              e.overrideErrorNotification({ errorMessage: 'Проблема с таким названием уже существует' });
              this.onSubmitError();
            }
          });
      }
      else {
        linkMessageWithIssue(autocompleteSelectedOption.value, messageId)
          .then(this.onSubmitSuccess)
          .catch(this.onSubmitError);
      }
    }
  };

  onSubmitSuccess = () => {
    const { onClose } = this.props;
    this.setState({
      isSubmitting: false,
      autocompleteOptions: [],
      autocompleteSelectedOption: null,
    });
    onClose();
  };

  onSubmitError = () => {
    this.setState({ isSubmitting: false });
  };

  focusInput = () => {
    try {
      requestAnimationFrame(() => {
        this.autocomplete.current.input.current.focus();
      });
    }
    catch (e) {}
  };

  render(){
    const { onClose } = this.props;
    const {
      isSubmitting,
      autocompleteQuery,
      autocompleteOptions,
      autocompleteSelectedOption,
    } = this.state;

    return (
      <Modal title="Связать с проблемой"
        onClose={onClose}
        verticallyCentered={true}>

        <div className={styles.value}>
          {!Boolean(autocompleteSelectedOption) && (
            <Autocomplete className={styles.autocomplete}
              items={autocompleteOptions}
              ref={this.autocomplete}
              placeholder="Краткое название проблемы"
              onSelect={this.onAutocompleteSelect}
              onType={autocompleteQuery => {
                this.setState({ autocompleteQuery });
                this.debouncedOnAutocompleteType(autocompleteQuery);
              }}
              overrideClassNames={{
                list: styles.autocompleteList,
              }}
              renderItem={item => (
                item.value !== 'new'
                  ? item.title
                  : (<span className={styles.autocompleteItemNew}>Создать: {autocompleteQuery}</span>)
              )}
            />
          )}

          {Boolean(autocompleteSelectedOption) && (
            <div className={styles.selectedOption}>
              {autocompleteSelectedOption.title}
              <i className={cn(styles.selectedOptionRemove, 'icon-close-thick')}
                onClick={this.onSelectedOptionRemove}/>
            </div>
          )}
        </div>

        <button className={cn({
          [uiStyles.buttonPrimary]: true,
          [styles.buttonSubmitting]: isSubmitting,
        })}
          onClick={this.onSubmitButtonClick}>
          {autocompleteSelectedOption?.value === 'new' ? 'Создать проблему' : 'Связать'}
        </button>
      </Modal>
    );
  }
}
